export default "__VITE_ASSET__u4g$4mjA__"